/* eslint-disable no-confusing-arrow */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-negated-condition */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import {
  BID_STATUS,
  // BidOrderType,
  activeAndInactivebidsColumns,
  childBidsColumns,
  currencyToLocal,
  defaultDeleteFilter,
  NumberWithCommasFormat,
  showSequenceNumber,
} from 'utils/constants';
import { isEmpty } from 'lodash';
import Loader from 'components/common/Loader';
import {
  LATEST_ALL_BIDS_QUERY,
  LATEST_ALL_BIDS_SUBSCRIPTION_QUERY,
} from 'utils/CommonGraphQL';
import { Button } from 'reactstrap';
import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
import { FaChevronDown } from 'react-icons/fa';
import './mobile.css';

const MOBILE_BID_TABS = ['Overview', 'Details', 'History'];

const getBidFilters = (currentStatus, dateRange) => {
  const baseFilters = [
    {
      key: 'parentBid',
      value: '',
      type: 'NULL',
      op: 'IS_NULL',
    },
    { ...defaultDeleteFilter },
  ];

  if (currentStatus && currentStatus !== 'ALL') {
    baseFilters.splice(1, 0, {
      key: 'status',
      value: currentStatus,
      type: 'STRING',
      op: 'EQ',
    });
  }

  if (dateRange?.startDate && dateRange?.endDate) {
    const startDate = new Date(dateRange.startDate);
    startDate.setHours(0, 0, 0, 0);

    const endDate = new Date(dateRange.endDate);
    endDate.setHours(23, 59, 59, 999);

    baseFilters.push({
      key: 'createdAt',
      value: `${startDate.valueOf()},${endDate.valueOf()}`,
      type: 'DATE',
      op: 'BTW',
    });
  }

  return baseFilters;
};

const ChildBids = ({ row }) => {
  return (
    <FSBTable
      keyField="id"
      columns={childBidsColumns}
      data={[row.original] || []} // Pass the single grouped bid
      totalCount={1}
      pagePerSize={1}
      search={false}
      pagination={false}
      isRowExpanded
      getRowCanExpand={() => false}
      showPagination={false}
      striped={false}
      hover={false}
      bordered={false}
    />
  );
};

const getLatestBidSource = (latestBid) =>
  latestBid?.bidType === 'OFFER' ? latestBid?.offer : latestBid?.demand;

const getTraderName = (trader) =>
  trader?.entityName ||
  [trader?.firstName, trader?.lastName].filter(Boolean).join(' ') ||
  'N/A';

const getTraderPhone = (trader) => {
  if (!trader?.phone) return 'No phone';
  return `${trader?.callingCode?.callingCode || trader?.callingCodeId || ''}${
    trader?.callingCode?.callingCode || trader?.callingCodeId ? '-' : ''
  }${trader?.phone}`;
};

const getBidStatusLabel = (status) => {
  switch (status) {
    case 'BID_ACTIVE':
    case 'BID_IN_PROGRESS':
      return 'Active';
    case 'BID_EXPIRED':
      return 'Expired';
    case 'BID_ACCEPTED':
      return 'Accepted';
    case 'BID_REJECTED':
      return 'Rejected';
    case 'BID_WITHDRAWN':
      return 'Withdrawn';
    default:
      return status || 'N/A';
  }
};

const getBidStatusClass = (status) => {
  switch (status) {
    case 'BID_ACTIVE':
    case 'BID_IN_PROGRESS':
    case 'BID_ACCEPTED':
      return 'success';
    case 'BID_EXPIRED':
      return 'warning';
    case 'BID_REJECTED':
    case 'BID_WITHDRAWN':
      return 'danger';
    default:
      return 'muted';
  }
};

const getGradeNames = (sourceData) =>
  (sourceData?.grades || [])
    .map((grade) => grade?.name)
    .filter(Boolean)
    .join(', ') || 'N/A';

const getLocationText = (sourceData) => {
  const portNames = (sourceData?.portsOfDischarge || [])
    .map((port) => port?.name)
    .filter(Boolean)
    .join(', ');
  return (
    [sourceData?.city?.cityName || portNames, sourceData?.state?.stateName]
      .filter(Boolean)
      .join(', ') || 'N/A'
  );
};

const getQtyUnit = (sourceData, fallbackUnit = '') =>
  sourceData?.actualQuantityUnit ||
  sourceData?.quantityUnit ||
  fallbackUnit ||
  '';

const getRateUnit = (sourceData, fallbackUnit = '') =>
  sourceData?.quantityUnit ||
  sourceData?.actualQuantityUnit ||
  fallbackUnit ||
  '';

const getFormattedBidDate = (value) => {
  if (!value) return 'N/A';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'N/A';
  return date.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

const getFormattedBidTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

const getGroupedBidKey = (groupedBid, index) =>
  groupedBid?.id || groupedBid?.latestBid?.id || `grouped-bid-${index}`;

const CommonBidDetails = ({
  status = BID_STATUS.IN_PROGRESS,
  // type = BidOrderType.OFFER,
  dateRange,
}) => {
  const [expandedMobileCardId, setExpandedMobileCardId] = useState(null);
  const [activeMobileTabs, setActiveMobileTabs] = useState({});
  const [filters, setFilters] = useState({
    filter: getBidFilters(status, dateRange),
    sortCol: 'latestBid.id',
    sortDirection: 'desc',
    pageNo: 1,
    pageSize: 10,
  });

  const { data, error, loading, subscribeToMore } = useQuery(
    LATEST_ALL_BIDS_QUERY,
    {
      variables: { ...filters },
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  );

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      filter: getBidFilters(status, dateRange),
    }));
  }, [status, dateRange]);

  const findIndexOfItem = (item) => {
    return activeAndInactivebidsColumns.findIndex(
      (itm) => itm.accessorKey === item,
    );
  };

  activeAndInactivebidsColumns[findIndexOfItem('SNo')].cell = ({
    cell,
    row,
  }) => {
    return (
      <div className="d-flex">
        {row.getCanExpand() ? (
          <Button
            color="link"
            className="text-decoration-none p-0 text-active"
            type="button"
            {...{
              onClick: row.getToggleExpandedHandler(),
              style: { cursor: 'pointer' },
            }}
          >
            {row.getIsExpanded() ? (
              <MdOutlineExpandLess className="me-2" size={20} />
            ) : (
              <MdOutlineExpandMore className="me-2" size={20} />
            )}
          </Button>
        ) : null}
        {showSequenceNumber(cell, filters)}
      </div>
    );
  };

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: LATEST_ALL_BIDS_SUBSCRIPTION_QUERY,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;

        return subscriptionData.data;
      },
    });

    return () => unsubscribe();
  }, []);

  if (loading && !data?.allBids?.groupedBids) return <Loader />;
  if (error && !data?.allBids?.groupedBids)
    return `There is an error on this page : ${error.message} `;
  if (!data?.allBids?.groupedBids) return 'Active Bids not available';
  const { totalCount, totalPages } = data.allBids;

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };

  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  const handleMobileTabChange = (bidId, tab) => {
    setActiveMobileTabs((prev) => ({
      ...prev,
      [bidId]: tab,
    }));
  };

  const toggleMobileCard = (bidId) => {
    setExpandedMobileCardId((prev) => (prev === bidId ? null : bidId));
  };

  const getMobilePillClass = (item) => {
    if (item.tone !== 'status') return 'muted';
    return getBidStatusClass(item.status);
  };

  const renderMobileDetailRows = (groupedBid, index, activeTab) => {
    const latestBid = groupedBid?.latestBid || {};
    const sourceData = getLatestBidSource(latestBid);
    const seller = sourceData?.trader;
    const qtyUnit = getQtyUnit(sourceData, latestBid?.quantityUnit);
    const rateUnit = getRateUnit(sourceData, latestBid?.quantityUnit);
    const sequenceNumber =
      ((filters?.pageNo || 1) - 1) * (filters?.pageSize || 10) + index + 1;
    const overviewRows = [
      { label: 'S.No', value: sequenceNumber },
      { label: 'Seller', value: getTraderName(seller) },
      { label: 'Seller phone', value: getTraderPhone(seller) },
      { label: 'Grade', value: getGradeNames(sourceData), tone: 'badge' },
      {
        label: 'Status',
        value: getBidStatusLabel(latestBid?.status),
        tone: 'status',
        status: latestBid?.status,
      },
      { label: 'Type', value: latestBid?.bidType || 'N/A', tone: 'badge' },
    ];

    const detailRows = [
      { label: 'Last bidder', value: getTraderName(latestBid?.bidder) },
      { label: 'Bidder phone', value: getTraderPhone(latestBid?.bidder) },
      { label: 'Location', value: getLocationText(sourceData) },
      {
        label: 'Total qty',
        value: `${NumberWithCommasFormat(sourceData?.totalQty)} ${qtyUnit}`,
      },
      {
        label: 'Min. qty',
        value: `${NumberWithCommasFormat(sourceData?.minimumQty)} ${qtyUnit}`,
      },
      {
        label: 'Rate',
        value: `${currencyToLocal(
          sourceData?.rate,
          latestBid?.rateUnit?.isoCurrencyCode,
        )}/${rateUnit}`,
      },
      {
        label: 'Bid rate',
        value: `${currencyToLocal(
          latestBid?.price,
          latestBid?.rateUnit?.isoCurrencyCode,
        )}/${rateUnit}`,
      },
      {
        label: 'Bid qty',
        value: `${NumberWithCommasFormat(latestBid?.quantity)} ${qtyUnit}`,
      },
      {
        label: 'Bid expire time',
        value: getFormattedBidDate(latestBid?.bidExpireTime),
      },
    ];

    const rows = activeTab === 'Overview' ? overviewRows : detailRows;

    return rows.map((item) => (
      <div className="bidding-mobile-card__detail-row" key={item.label}>
        <div className="bidding-mobile-card__detail-label">{item.label}</div>
        <div className="bidding-mobile-card__detail-value">
          {item.tone === 'status' || item.tone === 'badge' ? (
            <span
              className={`bidding-mobile-card__pill ${getMobilePillClass(item)}`}
            >
              {item.value}
            </span>
          ) : (
            item.value
          )}
        </div>
      </div>
    ));
  };

  const renderMobileHistory = (groupedBid) => {
    const bids = groupedBid?.allBids || [];
    const latestBid = groupedBid?.latestBid || {};
    const sourceData = getLatestBidSource(latestBid);
    const seller = sourceData?.trader;
    const qtyUnit = getQtyUnit(sourceData, latestBid?.quantityUnit);
    const rateUnit = getRateUnit(sourceData, latestBid?.quantityUnit);

    if (!bids.length) {
      return (
        <div className="bidding-mobile-history__empty">No bids available</div>
      );
    }

    return (
      <div className="bidding-mobile-history">
        <div className="bidding-mobile-history__listing">
          <div className="bidding-mobile-history__grade">
            {getGradeNames(sourceData)}
          </div>
          <div className="bidding-mobile-history__seller">
            {getTraderName(seller)}
          </div>
          <div className="bidding-mobile-history__seller-role">(Seller)</div>
          <div className="bidding-mobile-history__listing-row">
            <span>Offer Qty</span>
            <strong>
              {NumberWithCommasFormat(sourceData?.totalQty)} {qtyUnit}
            </strong>
          </div>
          <div className="bidding-mobile-history__listing-row">
            <span>Rate</span>
            <strong className="bidding-mobile-history__rate">
              {currencyToLocal(
                sourceData?.rate,
                latestBid?.rateUnit?.isoCurrencyCode,
              )}
              /{rateUnit}
            </strong>
          </div>
          <div className="bidding-mobile-history__listing-row">
            <span>Location</span>
            <strong>{getLocationText(sourceData)}</strong>
          </div>
        </div>

        <div className="bidding-mobile-history__title">
          <span>All Bids</span>
          <span className="bidding-mobile-card__pill muted">{bids.length}</span>
        </div>
        <div className="bidding-mobile-history__list">
          {bids.map((bid) => {
            const bidSourceData = getLatestBidSource(bid);
            const bidQtyUnit = getQtyUnit(bidSourceData, bid?.quantityUnit);
            const bidRateUnit = getRateUnit(bidSourceData, bid?.quantityUnit);
            const isSeller = bid?.bidderRole === 'SELLER';

            return (
              <div
                className={`bidding-mobile-history__item ${
                  isSeller ? 'seller' : 'buyer'
                }`}
                key={bid?.id || bid?.createdAt}
              >
                <div className="bidding-mobile-history__meta">
                  <span>{isSeller ? 'Seller' : 'Buyer'}</span>
                  <strong>{getTraderName(bid?.bidder)}</strong>
                </div>
                <div className="bidding-mobile-history__quote">
                  <span>
                    {NumberWithCommasFormat(bid?.quantity)} {bidQtyUnit}
                  </span>
                  <span>
                    {currencyToLocal(
                      bid?.price,
                      bid?.rateUnit?.isoCurrencyCode,
                    )}
                    /{bidRateUnit}
                  </span>
                </div>
                <div className="bidding-mobile-history__time">
                  {getFormattedBidTime(bid?.createdAt)}
                </div>
              </div>
            );
          })}
          <div
            className={`bidding-mobile-history__status ${getBidStatusClass(
              groupedBid?.latestBid?.status,
            )}`}
          >
            Last Bid:{' '}
            {currencyToLocal(
              groupedBid?.latestBid?.price,
              groupedBid?.latestBid?.rateUnit?.isoCurrencyCode,
            )}{' '}
            | Expired On:{' '}
            {getFormattedBidDate(groupedBid?.latestBid?.bidExpireTime)}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* <DownloadCSV
        lazyQuery={EXPORTS_TRADERS}
        filters={{
          ...filters,
          filter: [
            ...filters.filter,
            ...subscriberType,
            ...planExpiringType,
            { key: 'kycStatus', value: kycStatus, type: 'STRING', op: 'EQ' },
          ],
        }}
        apiKey="exportTraders"
        fileName="IndianVendors"
        positionTop={
          Object.keys(rowSelection).length || subscriberType.length
            ? '-80px'
            : '-30px'
        }
      /> */}
      <div className="bidding-mobile-list">
        {(data?.allBids?.groupedBids || []).map((groupedBid, index) => {
          const groupedBidKey = getGroupedBidKey(groupedBid, index);
          const latestBid = groupedBid?.latestBid || {};
          const sourceData = getLatestBidSource(latestBid);
          const seller = sourceData?.trader;
          const activeTab =
            activeMobileTabs[groupedBidKey] || MOBILE_BID_TABS[0];
          const isExpanded = expandedMobileCardId === groupedBidKey;
          const qtyUnit = getQtyUnit(sourceData, latestBid?.quantityUnit);
          const rateUnit = getRateUnit(sourceData, latestBid?.quantityUnit);

          return (
            <div className="bidding-mobile-card" key={groupedBidKey}>
              <div className="bidding-mobile-card__summary">
                <div className="bidding-mobile-card__identity">
                  <div className="bidding-mobile-card__name">
                    {getGradeNames(sourceData)}
                  </div>
                  <div className="bidding-mobile-card__meta">
                    {`${getTraderName(seller)} | ${getLocationText(sourceData)}`}
                  </div>
                  <div className="bidding-mobile-card__submeta">
                    {`Bid: ${currencyToLocal(
                      latestBid?.price,
                      latestBid?.rateUnit?.isoCurrencyCode,
                    )}/${rateUnit} | ${NumberWithCommasFormat(latestBid?.quantity)} ${qtyUnit}`}
                  </div>
                </div>
                <div className="bidding-mobile-card__aside">
                  <span
                    className={`bidding-mobile-card__pill ${getBidStatusClass(
                      latestBid?.status,
                    )}`}
                  >
                    {getBidStatusLabel(latestBid?.status)}
                  </span>
                  <button
                    type="button"
                    className={`bidding-mobile-card__expand-toggle ${
                      isExpanded ? 'is-open' : ''
                    }`}
                    onClick={() => toggleMobileCard(groupedBidKey)}
                    aria-expanded={isExpanded}
                    aria-label={
                      isExpanded ? 'Collapse bid details' : 'Expand bid details'
                    }
                  >
                    <FaChevronDown />
                  </button>
                </div>
              </div>

              {isExpanded && (
                <div className="bidding-mobile-card__body">
                  <div className="bidding-mobile-card__tabs">
                    {MOBILE_BID_TABS.map((tab) => (
                      <button
                        key={tab}
                        type="button"
                        className={`bidding-mobile-card__tab ${
                          activeTab === tab ? 'active' : ''
                        }`}
                        onClick={() =>
                          handleMobileTabChange(groupedBidKey, tab)
                        }
                      >
                        {tab}
                      </button>
                    ))}
                  </div>
                  {activeTab === 'History' ? (
                    renderMobileHistory(groupedBid)
                  ) : (
                    <div className="bidding-mobile-card__detail-list">
                      {renderMobileDetailRows(groupedBid, index, activeTab)}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {totalPages ? (
        <div className="bidding-mobile-pagination">
          <span className="bidding-mobile-pagination__count">
            {filters.pageNo} of {totalPages}
          </span>
          <select
            className="page-select form-select table-select f-12 fw-normal bidding-mobile-pagination__select"
            value={filters.pageSize}
            onChange={(e) => {
              const nextPageSize = Number(e.target.value);
              handlePageChange({
                pageNo: totalPages === filters.pageNo ? 1 : filters.pageNo,
                pageSize: nextPageSize,
              });
            }}
          >
            {[10, 20, 30, 40, 50].map((size) => (
              <option key={size} value={size}>
                {size} per page
              </option>
            ))}
          </select>
          <div className="pagination bidding-mobile-pagination__actions">
            <button
              type="button"
              onClick={() =>
                handlePageChange({ pageNo: 1, pageSize: filters.pageSize })
              }
              disabled={filters.pageNo <= 1}
            >
              {'<<'}
            </button>
            <button
              type="button"
              onClick={() =>
                handlePageChange({
                  pageNo: filters.pageNo - 1,
                  pageSize: filters.pageSize,
                })
              }
              disabled={filters.pageNo === 1}
            >
              {'<'}
            </button>
            <button
              type="button"
              onClick={() =>
                handlePageChange({
                  pageNo: filters.pageNo + 1,
                  pageSize: filters.pageSize,
                })
              }
              disabled={filters.pageNo >= totalPages}
            >
              {'>'}
            </button>
            <button
              type="button"
              onClick={() =>
                handlePageChange({
                  pageNo: totalPages,
                  pageSize: filters.pageSize,
                })
              }
              disabled={filters.pageNo >= totalPages}
            >
              {'>>'}
            </button>
          </div>
        </div>
      ) : null}

      <div className="bidding-mobile-hide-table">
        <FSBTable
          data={data?.allBids?.groupedBids || []}
          columns={activeAndInactivebidsColumns}
          totalCount={totalCount || 0}
          totalPages={totalPages || 0}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters={false}
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Vendors"
          SubComponent={ChildBids}
          // defaultSorting={defaultSorting}

          isRowExpanded={false}
          getRowCanExpand={() => true}
        />
      </div>
    </>
  );
};
export default CommonBidDetails;

// /* eslint-disable no-confusing-arrow */
// /* eslint-disable react/no-multi-comp */
// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable no-negated-condition */
// import React, { useEffect, useState } from 'react';
// import { useQuery } from '@apollo/client';
// import { FSBTable } from 'components/common/FSBTable';
// import {
//   BID_STATUS,
//   BidOrderType,
//   activeAndInactivebidsColumns,
//   childBidsColumns,
//   defaultDeleteFilter,
//   showSequenceNumber,
//   BID_STATUS_SORT_ORDER,
// } from 'utils/constants';
// import { isEmpty } from 'lodash';
// import Loader from 'components/common/Loader';
// import {
//   LATEST_ALL_BIDS_QUERY,
//   LATEST_ALL_BIDS_SUBSCRIPTION_QUERY,
// } from 'utils/CommonGraphQL';
// import { Button } from 'reactstrap';
// import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
// import DownloadCSV from 'components/DownloadCSV';
// import { EXPORTS_BIDS } from 'pages/BiddingOrders/BiddingOrderGraphQL';

// const ChildBids = ({ row }) => {
//   const { allBids } = row.original;

//   // Sort child bids if needed
//   const sortedChildBids = React.useMemo(() => {
//     if (!allBids || !Array.isArray(allBids)) return [];

//     return [...allBids].sort((a, b) => {
//       const statusA = a.status;
//       const statusB = b.status;

//       const orderA = BID_STATUS_SORT_ORDER[statusA] || 999;
//       const orderB = BID_STATUS_SORT_ORDER[statusB] || 999;

//       return orderA - orderB;
//     });
//   }, [allBids]);

//   return (
//     <FSBTable
//       keyField="id"
//       columns={childBidsColumns}
//       data={sortedChildBids || []}
//       totalCount={allBids?.length || 0}
//       pagePerSize={allBids?.length || 10}
//       search={false}
//       pagination={false}
//       isRowExpanded
//       getRowCanExpand={() => true}
//       showPagination={false}
//     />
//   );
// };

// const CommonBidDetails = ({
//   status = 'ALL',
//   type = BidOrderType.OFFER,
// }) => {
//   const [filters, setFilters] = useState({
//     filter: [
//       {
//         key: 'parentBid',
//         value: '',
//         type: 'NULL',
//         op: 'IS_NULL',
//       },
//       ...(status !== 'ALL' ? [{
//         key: 'status',
//         value: status,
//         type: 'STRING',
//         op: 'EQ',
//       }] : []),
//       { ...defaultDeleteFilter },
//     ],
//     sortCol: 'latestBid.status',
//     sortDirection: 'asc',
//     pageNo: 1,
//     pageSize: 10,
//   });

//   const { data, error, loading, subscribeToMore } = useQuery(
//     LATEST_ALL_BIDS_QUERY,
//     {
//       variables: { ...filters },
//       fetchPolicy: 'network-only',
//     },
//   );

//   const sortedData = React.useMemo(() => {
//     if (!data?.allBids?.groupedBids) return [];

//     return [...data.allBids.groupedBids].sort((a, b) => {
//       const statusA = a.latestBid?.status;
//       const statusB = b.latestBid?.status;

//       const orderA = BID_STATUS_SORT_ORDER[statusA] || 999;
//       const orderB = BID_STATUS_SORT_ORDER[statusB] || 999;

//       return orderA - orderB;
//     });
//   }, [data?.allBids?.groupedBids]);

//   useEffect(() => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       filter: prevFilters.filter.map((f) =>
//         f.key === 'status' ? { ...f, value: status } : f,
//       ),
//     }));
//   }, [status]);

//   const findIndexOfItem = (item) => {
//     return activeAndInactivebidsColumns.findIndex(
//       (itm) => itm.accessorKey === item,
//     );
//   };

//   activeAndInactivebidsColumns[findIndexOfItem('SNo')].cell = ({
//     cell,
//   }) => {
//     return (
//       <div>
//         {showSequenceNumber(cell, filters)}
//       </div>
//     );
//   };

//   useEffect(() => {
//     const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
//     const unsubscribe = subscribeToMore({
//       document: LATEST_ALL_BIDS_SUBSCRIPTION_QUERY,
//       variables: { ...filters, filter: deletedObj },
//       updateQuery: (prev, { subscriptionData }) => {
//         if (!prev || isEmpty(prev)) return '';
//         if (!subscriptionData.data) return prev;

//         return subscriptionData.data;
//       },
//     });

//     return () => unsubscribe();
//   }, []);

//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading) return <Loader />;
//   if (!data?.allBids?.groupedBids) return 'Active Bids not available';

//   const { totalCount, totalPages } = data.allBids;

//   const handlePageChange = ({ pageSize, pageNo }) => {
//     setFilters({
//       ...filters,
//       pageNo: totalCount < pageSize ? 1 : pageNo,
//       pageSize,
//     });
//   };

//   const onSortChange = (sort) => {
//     setFilters({
//       ...filters,
//       sortCol: sort()[0].id,
//       sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
//     });
//   };

//   const sortBy = [
//     filters.sortCol === null
//       ? { id: null, desc: null }
//       : {
//         id: filters.sortCol,
//         desc: filters.sortDirection === 'DESC',
//       },
//   ];

//   return (
//     <>
//       <DownloadCSV
//         lazyQuery={EXPORTS_BIDS}
//         filters={filters}
//         apiKey="exportBids"
//         fileName="Bids"
//         positionTop="-30px"
//         positionRight="20px"
//       />
//       <FSBTable
//         data={sortedData || []}
//         columns={activeAndInactivebidsColumns}
//         totalCount={totalCount || 0}
//         totalPages={totalPages || 0}
//         currentPageNo={filters.pageNo}
//         pageSize={filters.pageSize}
//         keyField="id"
//         showSearch={false}
//         showFilters={false}
//         showDelete={false}
//         showPagination
//         remote
//         striped={false}
//         hover={false}
//         bordered={false}
//         wrapperClass="table-responsive word-break"
//         handlePageChange={handlePageChange}
//         onSortChange={onSortChange}
//         sorting={sortBy}
//         searchPlaceholder="Search Vendors"
//         SubComponent={ChildBids}
//         isRowExpanded={false}
//         getRowCanExpand={() => true}
//       />
//     </>
//   );
// };

// export default CommonBidDetails;
